module.exports = __webpack_public_path__ + "img/d2e3e1b.svg";